export default __webpack_public_path__ + "static/media/css3.f625da0f.png";